module.exports = __webpack_public_path__ + "img/accesorios.1090b6f5.jpg";